import React from 'react';
import { getGuidesAdmin, deleteGuide } from '../../../api/contentAdminApi';
import {
	getGuideCategoryLabel,
	getGuidePublicPath,
	getGuideVisibility,
	GUIDES_INDEX_PATH,
} from '../../../data/guideCategoryMeta';
import { getPublicSiteUrl, isCmsPublished } from '../../../utils/cmsPublishHelpers';
import CmsAdminList from './CmsAdminList';

function appearsOnSummary(row) {
	const { hub } = getGuideVisibility(row.category);
	const parts = [GUIDES_INDEX_PATH];
	if (hub) parts.push(hub);
	return `Public listings: ${parts.join(', ')}`;
}

export default function GuidesAdminList() {
	return (
		<CmsAdminList
			title="Knowledge Guides"
			description="Create a guide → set status to Published → save. It appears on visitallnepal.com/guides and the category hub. Use View on site to confirm."
			addHref="/admin/cms/guide_form"
			formPath="/admin/cms/guide_form"
			resourceKey="guides"
			fetchList={getGuidesAdmin}
			deleteItem={deleteGuide}
			getRowSubtitle={(row) => getGuideCategoryLabel(row.category)}
			getAppearsOnSummary={(row) => (isCmsPublished(row) ? appearsOnSummary(row) : 'Draft — not on public site yet')}
			getViewOnSiteHref={(row) => (isCmsPublished(row) && row.slug ? getPublicSiteUrl(getGuidePublicPath(row.slug)) : null)}
		/>
	);
}
